// media-policy.js — decide whether the hero plays its Pexels video or shows
// only that clip's still photo ('poster' mode). Honors (in order):
//   1. Save-Data header             → poster
//   2. prefers-reduced-motion       → poster
//   3. connection.effectiveType 2g  → poster (cellular protection)
//   4. localStorage user pref       → 'poster' or 'video' wins
//   5. Battery <15% & not charging  → poster (best-effort; Chrome-only)
//   6. default                      → video (Wi-Fi/4G/3G handle 720p mp4 fine)

const PREF_KEY = 'weatherfcc:v32826:hero-mode';

export function readHeroPref() {
  try {
    const v = localStorage.getItem(PREF_KEY);
    if (v === 'video' || v === 'poster' || v === 'auto') return v;
  } catch (_) {}
  return 'auto';
}

export function setHeroPref(v) {
  if (!['video','poster','auto'].includes(v)) return;
  try { if (v === 'auto') localStorage.removeItem(PREF_KEY); else localStorage.setItem(PREF_KEY, v); } catch (_) {}
}

export function pickHeroMode() {
  if (typeof navigator === 'undefined') return 'poster';
  const conn = navigator.connection || {};
  if (conn.saveData) return 'poster';
  if (matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return 'poster';
  if (conn.effectiveType === '2g' || conn.effectiveType === 'slow-2g') return 'poster';
  const pref = readHeroPref();
  if (pref === 'poster') return 'poster';
  if (pref === 'video')  return 'video';
  return 'video';
}

// Best-effort battery downgrade — Chrome only; fails silently elsewhere.
// Returns a teardown to stop watching.
export function watchBattery(onLow) {
  if (typeof navigator === 'undefined' || typeof navigator.getBattery !== 'function') return () => {};
  let cancelled = false;
  let bat = null;
  const handler = () => { if (!cancelled && bat && bat.level < 0.15 && !bat.charging) onLow(); };
  navigator.getBattery().then((b) => {
    if (cancelled) return;
    bat = b;
    handler();
    b.addEventListener('levelchange', handler);
    b.addEventListener('chargingchange', handler);
  }).catch(() => {});
  return () => {
    cancelled = true;
    if (bat) {
      bat.removeEventListener?.('levelchange', handler);
      bat.removeEventListener?.('chargingchange', handler);
    }
  };
}
